export default __webpack_public_path__ + "static/media/330_dummy2016-heimtier01-de.1dc40d19.png";